import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import { PATHS } from "../../../../../constants/Define";
import { isEqual, get, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import VinWonderPrice from '../../../../../models/VinWonderPrice';
import Wrapper from './../../../common/component/Wrapper';
import PriceDetail from './PriceDetail';
import { message } from 'antd';

let permisionActions = [];
const defaultState = {
    action: "CREATE",
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

export default class VinWonderPriceDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            vinWonderPrice: this.props.vinWonderPriceState.detail.vinWonderPrice,
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    componentWillUnmount() {
        this.props.setVinWonderPriceDetail(new VinWonderPrice())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.vinWonderPriceState.detail.vinWonderPrice && !isEqual(nextProps.vinWonderPriceState.detail.vinWonderPrice, this.props.vinWonderPriceState.detail.vinWonderPrice)) {
            this.setState({ vinWonderPrice: nextProps.vinWonderPriceState.detail.vinWonderPrice, action: nextProps.vinWonderPriceState.detail.vinWonderPrice.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t, vinWonderPriceState } = this.props;
        const { isFetching } = vinWonderPriceState;
        const { action, isSubmit, isGetItem, validation, vinWonderPrice } = this.state;
        return (
            <LoadingComponent spinning={isFetching || isSubmit}>
                <PageListComponent className="vin-wonder-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'prices'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.vinWonderPrice.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.vinWonderPrice.title')}`.toLowerCase()))
                        }

                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        submitButtonRight={true}
                    >
                        <Wrapper className='col-md-12 p-0 m-0'>
                            <PriceDetail vinWonderPrice={vinWonderPrice} validation={validation} onChange={this.onChangeDetail} onChangeValue={this.onChangeValue}/>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.vin_wonder_id) {
            if (Object.keys(match.params).length > 0 && match.params.id) {
                const id = match.params.id;
                this.setState({ action: "UPDATE" });
                this.props.getVinWonderPriceDetail(id);
            }
        }
        
    }

    onChangeDetail = (fieldName, value) => {
        const price = this.state.vinWonderPrice;
        price[fieldName] = value;
        this.setState({ price });
    };

    onChangeValue = (fieldName, value) => {
        const newVal = value.replace(/,/g, "")
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(newVal) && reg.test(newVal)) || newVal === '' || newVal === '-') {
            this.onChangeDetail(fieldName, newVal);
        }
    }

    onSubmit = (e) => {
        const price = this.state.vinWonderPrice;
        e.preventDefault();
        if (this.validate()) {
            this.updateDetail()
        }
    };

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.vin_wonder_id) {
            const path = Func.getPathWithParams(PATHS.VIN_WONDER_PRICE.LIST.path, { vin_wonder_id: match.params.vin_wonder_id })
            this.props.history.push(path);
        }
    }

    validate() {
        const { t } = this.props;
        const vinWonderPrice = {...this.state.vinWonderPrice};
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderPrice.name`)),
                value: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderPrice.value`)),
                startDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderPrice.startDate`))
            },
            maxValueNumber: { value: t(`validation.percent`) },
            minValueNumber: { value: t(`validation.percent_negative`) }
        };
        let valueValidate = {
            maxValueNumber: {},
            minValueNumber: {}
        }
        const valueNumber = isNaN(vinWonderPrice.value) ? vinWonderPrice.value : vinWonderPrice.value.toString()
        if(vinWonderPrice.value && valueNumber.trim() === '-') {
            vinWonderPrice.value = 0
        }
        if(vinWonderPrice.type === 'Percentage') {
            valueValidate.maxValueNumber.value = 100;
            valueValidate.minValueNumber.value = -100;
        }
        const result = Func.multipleValidate(vinWonderPrice, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    updateDetail() {
        const { vinWonderPrice, action } = this.state;
        vinWonderPrice.vinWonderId = this.props.match.params.vin_wonder_id;
        vinWonderPrice.type = vinWonderPrice.type === 'Amount' ? 'money' : vinWonderPrice.type ;
        vinWonderPrice.type = vinWonderPrice.type === 'Percentage' ? 'percent' : vinWonderPrice.type ;
        const actionFunction = action === 'CREATE' ? this.props.createVinWonderPriceDetail : this.props.updateVinWonderPriceDetail;
        actionFunction(vinWonderPrice);
    }

}
